// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1kEZ5","calendarButtons":"ClockData_calendarButtons__2tUul"};